<template>
  <div>
    <div class="ele-table-tool ele-table-tool-default">
      <el-button @click="addLeaveGroup" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加审核组 </el-button>
    </div>
    <!-- 数据表格 -->
    <ele-data-table ref="table" :config="table" :current.sync="current" height="calc(100vh - 241px)" highlight-current-row>
      <el-table-column prop="levelName" label="审核组名称" sortable="custom" show-overflow-tooltip />
      <el-table-column prop="leaveLevel" label="审核级别" width="100" show-overflow-tooltip align="center" />
      <el-table-column label="审核人" sortable="custom" min-width="200px" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag v-for="(item, index) in row.tList" :key="index">{{ item.checkName }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280px" align="center" :resizable="false">
        <template #default="{ row }">
          <el-link @click="addTeacher(row)" icon="el-icon-user" type="primary" :underline="false">绑定审核人</el-link>
          <el-link @click="editGroup(row)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
          <el-popconfirm title="确定要删除此审核组吗？" @onConfirm="removeGroup(row)" class="ele-action">
            <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
          </el-popconfirm>
        </template>
      </el-table-column>
    </ele-data-table>
    <!--编辑弹窗-->
    <el-dialog
      :title="editForm.id ? '修改审核组' : '添加审核组'"
      :visible.sync="showEdit"
      width="400px"
      @closed="editForm = {}"
      :destroy-on-close="true"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="审核组名称:" prop="levelName">
          <el-input v-model="editForm.levelName" placeholder="请输入审核组名称" clearable maxlength="10" show-word-limit />
        </el-form-item>
        <el-form-item label="排序号:" prop="orderNumber">
          <el-input-number
            v-model="editForm.orderNumber"
            controls-position="right"
            :min="0"
            placeholder="请输入排序号"
            class="ele-fluid ele-text-left"
          />
        </el-form-item>
        <el-form-item label="审核级别:" prop="leaveLevel">
          <el-select v-model="editForm.leaveLevel" placeholder="请选择">
            <el-option :value="1" label="一级审核" />
            <el-option :value="2" label="二级审核" />
            <!--            <el-option :value="3" label="三级审核"></el-option>-->
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="saveGroup(editForm.id)">保存</el-button>
      </div>
    </el-dialog>
    <!-- 添加审核教师弹窗 -->
    <el-dialog
      title="添加教师"
      :visible.sync="showTeacherEdit"
      width="650px"
      @closed="teacherForm = {}"
      :destroy-on-close="true"
      :lock-scroll="false"
    >
      <el-form :model="teacherForm" ref="teacherForm" label-width="100px">
        <el-form-item label="教师:">
          <treeselect
            v-model="teacherForm.teacherIds"
            :options="teacherList"
            :required="true"
            :multiple="true"
            placeholder="请选择教师"
            :defaultExpandLevel="2"
            valueConsistsOf="LEAF_PRIORITY"
            :normalizer="
              (d) => {
                return { id: d.id, label: d.name };
              }
            "
            style="line-height: 20px"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showTeacherEdit = false">取消</el-button>
        <el-button type="primary" @click="saveTeacher">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'; // 下拉树
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  import {
    getAllDepartTeachers,
    saveCheckGroupTeacher,
    deleteCheckGroupTeacher,
    saveCheckGroupTeacherAndLevelC,
    deleteCheckGroupTeacherAndLevel,
    updateLevelGroup,
  } from '@/config/api';

  export default {
    name: 'Approval',
    components: { Treeselect },
    props: {
      groupId: Number,
    },
    data() {
      return {
        table: {
          // 表格配置
          url: '/teacherLeave/showCheckGroupTeacherAndLevel',
          page: false,
          where: { groupId: this.groupId },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        current: null, // 表格选中数据
        showEdit: false, // 是否显示表单弹窗
        editForm: {
          leaveLevel: '',
          levelName: '',
          orderNumber: '',
        }, // 表单数据
        editRules: {
          // 表单验证规则
          levelName: [{ required: true, message: '请输入审核组名称', trigger: 'blur' }],
          orderNumber: [{ required: true, message: '请输入序号', trigger: 'blur' }],
          leaveLevel: [{ required: true, message: '请选择审核级别', trigger: 'change' }],
        },
        showTeacherEdit: false,
        teacherForm: {},
        teacherList: [], //老师数据
      };
    },
    watch: {
      /* 监听机构id变化 */
      groupId() {
        this.table.where.groupId = this.groupId;
        this.$refs.table.reload();
      },
    },
    methods: {
      // 添加审核组
      addLeaveGroup() {
        this.showEdit = true;
        this.editForm.groupId = this.groupId;
      },
      // 编辑审核组
      editGroup(row) {
        this.editForm = Object.assign({}, row);
        this.showEdit = true;
      },
      // 保存审核组
      saveGroup(id) {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            // formData.append('groupId', this.groupId);
            if (id == undefined) {
              //添加审核组
              saveCheckGroupTeacherAndLevelC(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.$message({
                    type: 'success',
                    message: '添加成功!',
                  });
                  this.showEdit = false;
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            } else {
              //编辑审核组
              // formData.append('id', id);
              updateLevelGroup(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.$message({
                    type: 'success',
                    message: '修改成功!',
                  });
                  this.showEdit = false;
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      // 删除审核组
      removeGroup(row) {
        let formData = new FormData();
        formData.append('id', row.id);
        deleteCheckGroupTeacherAndLevel(formData).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 添加审核组审核人
      addTeacher(row) {
        this.showTeacherEdit = true;
        this.teacherForm.levelId = row.id;
        this.teacherForm.teacherIds = row.tList.map((d) => d.checkId);
        this.queryDept();
      },
      //查询部门列表
      queryDept() {
        getAllDepartTeachers()
          .then((res) => {
            if (res.data.resCode == 200) {
              this.teacherList = this.$util.toTreeData(res.data.data, 'id', 'parentId');
              this.deleteChildren(this.teacherList);
            } else {
              this.$message.error(res.data.resMsg);
            }
          })
          .catch((e) => {
            this.$message.error(e.message);
          });
      },
      // 循环数组 children为空时删除 且部系年级下无children时禁用
      deleteChildren(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].children) {
            if (data[i].children.length) {
              this.deleteChildren(data[i].children);
            } else {
              if (data[i].type !== 2) {
                delete data[i].children;
                data[i].isDisabled = true;
              }
            }
          }
        }
        return data;
      },
      // 添加审核教师
      saveTeacher() {
        let teacherIds = [...new Set(this.teacherForm.teacherIds)]; //js去重
        this.$refs['teacherForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.teacherForm) {
              if (this.teacherForm[key] !== null && this.teacherForm[key] !== undefined) {
                formData.append(key, this.teacherForm[key]);
              }
            }
            formData.set('teacherIds', teacherIds);
            saveCheckGroupTeacher(formData).then((res) => {
              loading.close();
              if (res.data.resCode == '200') {
                this.showTeacherEdit = false;
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
      // 取消添加审核教师
      removeTeacher(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('groupId', row.groupId);
        formData.append('teacherId', row.checkId);
        deleteCheckGroupTeacher(formData).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: res.data.resMsg });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
    },
  };
</script>

<style scoped></style>
